<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ref, watch } from "vue";
import dayjs from "dayjs";

const props = defineProps({
  range: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: [String, Array],
    default: null,
  },
  minDate : {
    required: true,
  },
  maxDate : {
    required: true,
  },
  allowedDates: {
    type: Array,
    default: () => null,
  },
  disabledDates: {
    type: Array,
    default: () => null,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  enableTimePicker: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits([
  'update:modelValue',
  'update-month-year',
  'first-date-selected',
]);

const date = ref(null);
date.value = props.modelValue;

// watch date and emit the value
watch(date, (value) => {
  emit('update:modelValue', value);
});

watch(() => props.modelValue, (value) => {
  date.value = value;
  if (!value) {
    dp.value.clearValue();
  }
});

const handleMonthYear = ({ instance, month, year }) => {
  emit('update-month-year', { month, year })
}

const handleInternalModelChange = (value) => {
  if (Array.isArray(value) && value.length === 1) {
    emit('first-date-selected', value[0])
  }
}

const dp = ref();
const getDuration = (value) => {
  if (Array.isArray(value)  && value.length === 2) {
    const start = value[0];
    const end = value[1];
    return dayjs(end).diff(dayjs(start), 'days');
  }
  return 0;
}
const selectDate = () => {
  dp.value.selectDate();
}

const formatDateInput = (date) => {
  if (Array.isArray(date)  && date.length === 2) {
    return `${dayjs(date[0]).format('LL')} - ${dayjs(date[1]).format('LL')}`;
  } else if (date && props.enableTimePicker) {
    return dayjs(date).format('LLL');
  } else if (date && !props.enableTimePicker) {
    return dayjs(date).format('LL');
  }
  return '';
}

</script>

<template>
  <VueDatePicker
    :range="range"
    :locale="$i18n.locale"
    :min-date="minDate"
    :max-date="maxDate"
    :allowed-dates="allowedDates"
    :disabled-dates="disabledDates"
    :format="formatDateInput"
    :config="{ noSwipe: true }"
    text-input
    input-class-name="form-control"
    v-model="date"
    utc
    :inline="inline"
    :loading="loading"
    :enable-time-picker="enableTimePicker"
    @update-month-year="handleMonthYear"
    @internal-model-change="handleInternalModelChange"
    auto-apply
    ref="dp">
    <template #action-preview="{ value }">
      {{ $t('numberOfDays', { d: getDuration(value)  }, getDuration(value)) }}
    </template>
    <template #action-buttons>
      <button class="btn btn-sm btn-primary" @click="selectDate">Select</button>
    </template>
  </VueDatePicker>
</template>
